module.exports = __webpack_public_path__ + "img/تلفیقی.ab226e03.png";